import React, { useEffect, useState } from 'react'
import cls from './drawer.module.scss'
import cn from 'classnames'
import { useDrawer } from '@/src/app/providers/DrawerProvider'

export const Drawer = () => {
  const { isOpen, content, settings } = useDrawer()
  const [renderedDrawer, setRenderedDrawer] = useState({ content, settings })

  useEffect(() => {
    if (isOpen) setRenderedDrawer({ content, settings })
  }, [content, isOpen, settings])

  const visibleContent = isOpen ? content : renderedDrawer.content
  const visibleSettings = isOpen ? settings : renderedDrawer.settings
  const { width = 280 } = visibleSettings

  const handleTransitionEnd = event => {
    if (event.target !== event.currentTarget || event.propertyName !== 'width' || isOpen) return
    setRenderedDrawer({ content: null, settings: {} })
  }

  return (
    <div
      className={cn(cls.drawerContainer, { [cls.open]: isOpen })}
      style={{ '--drawer-width': `${width}px` }}
      onTransitionEnd={handleTransitionEnd}
    >
      <aside className={cls.drawer}>{visibleContent}</aside>
    </div>
  )
}
